import {mapToMaterialsById, Material, useMaterials} from '@domain/materials'
import {useUpmPlantContext} from '@hconnect/upm'
import {Navigate, Outlet} from 'react-router'

import {ROUTES, getUrl} from '../../../routing'
import {PlannerPageSkeleton} from '../../../shared/components/skeletons/PlannerPageSkeleton'
import {useUrlParam} from '../../../shared/hooks/useUrlParam'

export const MaterialIdGuard: React.FC = () => {
  const materialId = useUrlParam('materialId')
  const {plantId: plantCode} = useUpmPlantContext()
  const {data: materialsById} = useMaterials({
    plantCode,
    options: {
      select: mapToMaterialsById
    }
  })

  if (materialsById === undefined) {
    return <PlannerPageSkeleton />
  }

  const currentMaterial: Material | undefined = materialsById[materialId]

  if (currentMaterial === undefined) {
    return <Navigate to={getUrl(ROUTES.BASE.NOT_FOUND.path, {})} replace />
  }

  return <Outlet />
}
